import { streamAgentChat } from './streamAgentChat';

const PROPERTY_CHAT_ENDPOINT = '/ps/integrations/agents/property/chat/stream';

/**
 * Streaming client for the Property Intelligence agent. Thin wrapper over the
 * shared streamAgentChat core — see ./streamAgentChat for the SSE-parsing and
 * abort behaviour. Kept as a named export so existing imports stay stable.
 */
export function streamPropertyAgentChat({
  history,
  context,
  sessionId,
  tools,
  signal,
  onText,
  onToolUse,
  onDone,
  onError,
}) {
  return streamAgentChat({
    endpoint: PROPERTY_CHAT_ENDPOINT,
    history,
    context,
    sessionId,
    tools,
    signal,
    onText,
    onToolUse,
    onDone,
    onError,
  });
}
